import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { EventTrackerNavigationReasons } from 'src/app/shared/constants';
import { PageCardButton } from '../types/PageCardButton.types';

@Component({
    selector: 'app-page-card-new',
    imports: [
        // Angular
        CommonModule,
        // Angular Material
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        // Own
    ],
    templateUrl: './page-card-new.component.html',
    styleUrl: './page-card-new.component.scss',
})
export class PageCardNewComponent {
    protected EventTrackerNavigationReasons = EventTrackerNavigationReasons;

    @Input({ required: true })
    title!: string;

    @Input({ required: true })
    content!: string;

    @Input()
    cardClass?: string;

    @Input()
    headerClass?: string;

    @Input()
    titleClass?: string;

    @Input()
    contentClass?: string;

    @Input()
    iconName?: string;

    @Input()
    iconClass?: string;

    @Input()
    buttons?: PageCardButton[];

    @Output()
    buttonClicked: EventEmitter<PageCardButton> = new EventEmitter();

    constructor() {}

    protected clickButton(button: PageCardButton): void {
        this.buttonClicked.emit(button);
    }
}
